"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const CommonSeedDropTable_1 = __importDefault(require("../../../subtables/CommonSeedDropTable"));
const HerbDropTable_1 = __importDefault(require("../../../subtables/HerbDropTable"));
const RareDropTable_1 = require("../../../subtables/RareDropTable");
const AnkouTable = new LootTable_1.default({ limit: 100 })
    .every('Bones')
    .oneIn(33, 'Left skull half')
    /* Weapons and armor */
    .add('Black knife', 1, 1)
    .add('Black robe', 1, 1)
    /* Runes and ammunition */
    .add('Death rune', 10, 10)
    .add('Blood rune', 11, 6)
    .add('Law rune', 2, 6)
    .add('Adamant arrow', [5, 14], 4)
    .add('Blood rune', 5, 3)
    /* Herbs */
    .add(HerbDropTable_1.default, 1, 3)
    /* Seeds */
    .add(CommonSeedDropTable_1.default, 1, 1)
    /* Materials */
    .add('Pure essence', 15, 5)
    .add('Mithril ore', [3, 7], 2)
    /* Coins */
    .add('Coins', 8, 33)
    .add('Coins', [5, 204], 10)
    /* Other */
    .add('Bass', 1, 2)
    .add('Weapon poison', 1, 2)
    .add('Fried mushrooms', 1, 1)
    /* RDT */
    .add(RareDropTable_1.GemTable, 1, 2)
    /* Tertiary */
    .tertiary(512, 'Clue scroll (hard)');
exports.default = new SimpleMonster_1.default({
    id: 2514,
    name: 'Ankou',
    table: AnkouTable,
    aliases: ['ankou', 'ank']
});
//# sourceMappingURL=Ankou.js.map